import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import React, { useEffect, useState } from 'react'

import LeftRecipeArrow from '../../../../images/recipes/recipe-left-arrow.svg'

import './recipe.css'

export interface IRecipeHeroProps {
  backgroundColor: string
  backgroundImage: any
  cloudinaryHeroImage: any
  builderHeroImage: any
  heroImagePosition: string
  recipeTitle: string
  recipeTitleColor: string
  recipeSummary: string
  recipeSummaryColor: string
  heroImage: any
  recipeAdultOnly: boolean
}

const RecipeHero = ({
  backgroundColor,
  backgroundImage = '',
  cloudinaryHeroImage,
  builderHeroImage,
  heroImagePosition,
  recipeTitle,
  recipeSummary,
  heroImage,
  recipeTitleColor,
  recipeSummaryColor,
  recipeAdultOnly
}: IRecipeHeroProps) => {
  const [arrowLeftOffset, setArrowLeftOffset] = useState(0)
  const [recipeSummaryLeftOffset, setRecipeSummaryLeftOffset] = useState(0)
  let timeOutInterval: any = null

  const adjustHeroArrow = () => {
    const titleElement: any = document.getElementById('recipe-hero-title')
    clearTimeout(timeOutInterval)
    if (titleElement) {
      timeOutInterval = setTimeout(() => {
        const leftOffset = titleElement?.parentElement?.offsetLeft
        // console.log('TITLE LEFT OFFSET', leftOffset)
        setArrowLeftOffset(leftOffset)

        const titleArrowElement = document.getElementsByClassName('recipe-hero-title-arrow')[0]
        if (titleArrowElement?.clientWidth) {
          const summaryLeftOffset = leftOffset + titleArrowElement?.clientWidth - 20
          console.log('ARROW ELEMENT WIDTH', titleArrowElement?.clientWidth, summaryLeftOffset)
          setRecipeSummaryLeftOffset(summaryLeftOffset)
          // console.log('-------------------------------')
          titleArrowElement.classList.add('recipe-hero-title-arrow-show')
          titleArrowElement.classList.remove('opacity-0')
        }
        const recipeSummaryElement = document.getElementsByClassName('recipe-summary')[0]
        if (recipeSummaryElement) {
          recipeSummaryElement.classList.add('recipe-summary-show')
          recipeSummaryElement.classList.remove('opacity-0')
          recipeSummaryElement.style.top = `${titleArrowElement?.offsetTop + titleArrowElement?.clientHeight - 30}px`
        }

        adjustTopContainerHeight()
      }, 200)
    }
  }

  const adjustTopContainerHeight = () => {
    const heightAdjustElement: any = document.getElementsByClassName('hero-recipe-top-part')[0]
    const heightAdjustForTopImageWrapper: any = document.getElementById('hero-top-bg-wrapper')

    const titleElement = document.getElementsByClassName('recipe-title')[0]
    const summaryElement = document.getElementsByClassName('recipe-summary')[0]

    const desiredHeight = titleElement?.clientHeight + summaryElement?.clientHeight + 70

    if (heightAdjustElement) {
      heightAdjustElement.style.height = `${desiredHeight}px`
    }
    if (heightAdjustForTopImageWrapper) {
      heightAdjustForTopImageWrapper.style.height = `${desiredHeight + 100}px`
    }
  }

  useEffect(() => {
    adjustHeroArrow()
    adjustTopContainerHeight()
  }, [recipeTitle, recipeSummaryLeftOffset])

  useEffect(() => {
    addEventListener('resize', adjustHeroArrow)

    return () => {
      removeEventListener('resize', adjustHeroArrow)
    }
  }, [])

  const renderTopAreaTextBGImage = () => {
    if (backgroundImage) {
      return (
        <div className="index-0 hero-top-bg-wrapper w-full" id="hero-top-bg-wrapper">
          <img className="hero-top-bg-img w-full" src={backgroundImage} />
        </div>
      )
    }
    return null
  }

  return (
    <div className="relative w-full" style={{ backgroundColor }}>
      {renderTopAreaTextBGImage()}
      <div className="hero-recipe-top-part index-1 container relative mx-auto flex justify-center">
        <div className="recipe-title absolute flex justify-center">
          <h1
            className={`w-fit ${recipeTitle.length > 18 ? 'text-2xl md:text-4xl' : 'text-3xl md:text-7xl'}`}
            id="recipe-hero-title"
            style={{ color: recipeTitleColor }}
          >
            {recipeTitle}
          </h1>
        </div>

        <img
          className="recipe-hero-title-arrow absolute opacity-0"
          style={{ left: `${arrowLeftOffset}px` }}
          src={LeftRecipeArrow}
        />

        <h3
          className="recipe-summary top-[50%] md:top-[60%] font-third absolute text-2xl opacity-0 md:text-5xl"
          style={{ left: `${recipeSummaryLeftOffset}px`, color: recipeSummaryColor }}
        >
          {recipeSummary}
        </h3>
      </div>
      <div className="index-1 w-full">
        <CdnImage
          className="h-[32rem] w-full object-cover"
          url={builderHeroImage}
          lazyLoad={false}
          // renderPlaceholder={false}
          steps={[768, 1021, 1500]}
          style={{
            maxWidth: '100%',
            objectFit: 'cover',
            objectPosition: heroImagePosition || '50% 50%'
          }}
        />
      </div>
      <div className="z-index-1 relative mx-auto -mt-4 w-3/4 md:w-1/2 lg:-mt-6 lg:w-1/3">
        {recipeAdultOnly && (
          <div className="z-10 mx-auto -mt-2 mb-2 w-full justify-center rounded-full bg-[#D1D5DA] py-2 text-center font-serif text-xs md:text-sm lg:mb-0 lg:w-[70%] lg:px-2">
            For adult dogs only. Not suitable for pregnant or nursing dogs
          </div>
        )}
      </div>
    </div>
  )
}

export default RecipeHero

export const RecipeHeroProps = {
  name: 'recipeHero',
  type: 'object',
  defaultValue: {
    backgroundColor: '#004355',
    backgroundImage: null,
    recipeTitle: '',
    recipeSummary: '',
    cloudinaryHeroImage: null,
    builderHeroImage: null,
    heroImagePosition: '50% 50%',
    recipeTitleColor: 'black',
    recipeSummaryColor: 'black',
    adultOnly: false
  },
  subFields: [
    { name: 'backgroundColor', type: 'color', defaultValue: '#004355' },
    { name: 'backgroundImage', type: 'file', defaultValue: null },
    { name: 'recipeTitle', type: 'string', defaultValue: '' },
    { name: 'recipeTitleColor', type: 'color', defaultValue: 'black' },
    {
      name: 'recipeSummary',
      type: 'text',
      defaultValue: ''
    },
    { name: 'recipeSummaryColor', type: 'color', defaultValue: 'black' },
    { name: 'heroImage', type: 'file', defaultValue: null },
    // { name: 'cloudinaryHeroImage', type: 'cloudinaryImageEditor' },
    {
      name: 'builderHeroImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'heroImagePosition',
      type: 'string',
      enum: ['50% 50%', 'bottom'],
      defaultValue: '50% 50%'
    },
    {
      name: 'adultOnly',
      type: 'boolean',
      defaultValue: false
    }
  ]
}
